<template>
  <img
    :src="require('./330px-Flag_of_Singapore.svg.png')"
    width="24"
    height="16"
    style="object-fit: cover; border-radius: 2px;"
    alt="Singapore"
  />
</template>

<script>
export default {
  name: 'SingaporeFlag',
}
</script>
